import { FC } from "react";
import { Card, CardMedia } from "@material-ui/core";

import PoolDetailStyle from "./DetailsStyle";

type ProjectBannerProps = {
    type: "image" | "video";
    url: string
}

const ProjectBanner: FC<any> = ({ name, spotlight }) => {

    const classes = PoolDetailStyle();

    const { type, url } = spotlight;

    const renderMedia = () => {
        if (type === "image") {
            return (
                <CardMedia
                    image={url}
                    title={name + " Pool Detail GainsPad"} // Change to pool name
                    component="img"
                    className={classes.bannerImage}
                />
            );
        } else if (type === "video") {
            return (
                <CardMedia
                    component="video"
                    src={url}
                    title={name + " Pool Detail GainsPad"} // Change to pool name
                    controls
                    className={classes.bannerImage}
                />
            );
        }
    };

    return (
        <Card className={classes.banner}>
            {renderMedia()}
        </Card>
    );
}

export default ProjectBanner;
